<div class="row ">
    <div class="col-lg-5"></div>
    <div class="col-lg-2 text-center d-flex justify-content-center">
        <div class="p-3 form-signin">
            <h4>Welcome!</h4>
            <h5>Please Log In</h5>
            <label for="inputEmail" class="sr-only">User Name</label>
            <input [(ngModel)]="userName" type="username" id="inputUser" class="form-control mb-3 " placeholder="User Name" required="" autofocus="">
            <label for="inputPassword" class="sr-only">Password</label>
            <input (keyup.enter)="postAuthCall();" [(ngModel)]="password" type="password" id="inputPassword" class="form-control mb-3 " placeholder="Password" required="">
            <button class="btn btn-lg btn-clover btn-block" (click)="postAuthCall();">Log In</button>
            <button class="btn btn-lg btn-clover btn-block mb-3" (click)="updatePW();">Update Password</button>
            <div *ngIf="newPW">
                <label for="inputNewPassword" class="sr-only">New Password</label>
                <input [(ngModel)]="newPassword" type="password" id="inputNewPassword" class="form-control mb-3 " placeholder="New Password" required="">
                <label for="inputConfirmPassword" class="sr-only">New Password, Again</label>
                <input [(ngModel)]="newPasswordConfirm" type="password" id="inputConfirmPassword" class="form-control mb-3 " placeholder="New Password" required="">
            </div>
            <p class="text-center mt-2 text-danger">{{infoBox}}</p>
        </div>
    </div>
    <div class="col-lg-5"></div>
</div>